// Firebase init. Config values come from Squashboard's prod project
// (squint-mobile-backend-prod) because that's the project squapi's
// /v1/user/ endpoint accepts JWTs from.
//
// These values are safe to commit — Firebase web configs are public-by-design
// (see https://firebase.google.com/docs/web/learn-more#config-object).
import { initializeApp } from "firebase/app";
import {
  browserLocalPersistence,
  getAuth,
  setPersistence,
} from "firebase/auth";

const app = initializeApp({
  apiKey: "AIzaSyCGVnFkKI_2DLagDwxKbxHyL5L3SYURG1w",
  authDomain: "squint-mobile-backend-prod.firebaseapp.com",
  projectId: "squint-mobile-backend-prod",
  storageBucket: "squint-mobile-backend-prod.appspot.com",
  messagingSenderId: "770314039651",
  appId: "1:770314039651:web:ba026fc5b367c1ee23e356",
});

export const auth = getAuth(app);

// Survive reloads so the sign-in isn't lost every dev-server restart.
setPersistence(auth, browserLocalPersistence).catch(console.error);
